import React from 'react';
import { HospitalInfo } from '../types';

interface HeaderProps {
  hospital: HospitalInfo;
  showLogo?: boolean;
  variant?: 'full' | 'compact' | 'minimal' | 'centered';
}

export default function Header({ hospital, showLogo = true, variant = 'full' }: HeaderProps) {
  if (variant === 'centered') {
    return (
      <div 
        className="text-center mb-2"
        style={{
          fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
          WebkitPrintColorAdjust: 'exact',
          printColorAdjust: 'exact',
        }}
      >
        {showLogo && hospital.logo && (
          <img 
            src={hospital.logo} 
            alt="logo" 
            className="h-14 w-auto mx-auto mb-2" 
            crossOrigin="anonymous"
          />
        )}
        <div className="text-[#16A34A] font-extrabold text-[22px] uppercase tracking-wide">
          {hospital.name}
        </div>
        {hospital.banglaSubtitle && (
          <div className="text-[#1B75BC] font-semibold text-[15px] mt-0.5">
            {hospital.banglaSubtitle}
          </div>
        )}
        <div className="text-[13px] text-[#111827] mt-0.5">
          {hospital.address}
          {hospital.phone ? ` · ${hospital.phone}` : ''}
        </div>
        <div className="w-[220px] h-[1px] bg-black mx-auto mt-2 mb-1.5" />
      </div>
    );
  }

  if (variant === 'minimal') {
    return (
      <div className="text-center mb-4">
        <h1 className="text-2xl font-bold text-gray-900">{hospital.name}</h1>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="flex items-center justify-between mb-4 pb-4 border-b-2 border-primary-600">
        {showLogo && hospital.logo && (
          <img src={hospital.logo} alt={hospital.name} className="h-12 w-auto" crossOrigin="anonymous" />
        )}
        <div className={showLogo && hospital.logo ? 'text-right' : 'text-center flex-1'}>
          <h1 className="text-xl font-bold text-gray-900">{hospital.name}</h1>
          <p className="text-sm text-gray-600">{hospital.phone}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <div className="flex items-start justify-between mb-4">
        {showLogo && hospital.logo && (
          <div className="flex-shrink-0">
            <img src={hospital.logo} alt={hospital.name} className="h-16 w-auto" crossOrigin="anonymous" />
          </div>
        )}
        <div className={showLogo && hospital.logo ? 'text-right' : 'text-center flex-1'}>
          <h1 className="text-3xl font-bold text-primary-600 mb-2">{hospital.name}</h1>
          <p className="text-sm text-gray-600">{hospital.address}</p>
          <p className="text-sm text-gray-600">Phone: {hospital.phone}</p>
          {hospital.email && <p className="text-sm text-gray-600">Email: {hospital.email}</p>}
          {hospital.website && <p className="text-sm text-gray-600">{hospital.website}</p>}
        </div>
      </div>
      <div className="border-t-2 border-primary-600"></div>
    </div>
  );
}
